import { migrateBrowserStorageKeys } from './utils/storageKeyMigration';

migrateBrowserStorageKeys();
